// extracted by mini-css-extract-plugin
module.exports = {"predictions":"AutoComplete_predictions__2ryie","selected":"AutoComplete_selected__2AO_R"};